import { render, staticRenderFns } from "./DueDiligenceExemptionForm.vue?vue&type=template&id=8fa18484&scoped=true&"
import script from "./DueDiligenceExemptionForm.vue?vue&type=script&lang=js&"
export * from "./DueDiligenceExemptionForm.vue?vue&type=script&lang=js&"
import style0 from "./DueDiligenceExemptionForm.vue?vue&type=style&index=0&id=8fa18484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa18484",
  null
  
)

export default component.exports